/* eslint-disable @typescript-eslint/no-explicit-any */
import mitt, { type Handler } from '@meesayen/mitt'
import { useRollbar } from './rollbar'

const emitter = mitt()

type EventType = 'error:viz' | 'error:generic'
interface ErrorData extends Event {
  msg: string
  extras: any
}

function listen(type: EventType, fn: Handler<ErrorData>) {
  emitter.on(type, fn as Handler<unknown>)
}

export function install() {
  const rollbar = useRollbar()

  listen('error:viz', e => {
    rollbar.error(e.msg, e.extras)
    // eslint-disable-next-line
    console.error(e)
  })
  listen('error:generic', e => {
    rollbar.error(e.msg, e.extras)
    // eslint-disable-next-line
    console.error(e)
  })
}

export function throwVizError(msg: string, extras?: any) {
  emitter.emit('error:viz', { msg, extras: { ...extras } })
}

export function throwError(msg: string, extras?: any) {
  emitter.emit('error:generic', { msg, extras })
}
